export const themes = {
  default: ({ author = {} }) => ({
    thRoot: 'flex flex-col',
    thTop: 'flex items-center mb-3',
    thBadge: 'rtl:mr-2 flex-shrink-0',
    thBadgeIconSize: '1rem',
    thBadgeSize: 40,
    thBadgeVariant: 'pill',
    thAuthor: `text-${author.color ? author.color : 'gray-dark'} text-base`,
    thDate: 'text-base text-gray-light rtl:ml-5',
    thTitle: '',
    thTitleTheme: 'title-sans-3',
    thText: 'mt-2',
    thBottom: 'flex items-center mt-auto pt-3 text-md',
    thIcon: 'rtl:mr-1',
    thIconSize: '1.25rem',
    thLikes: 'inline-flex items-center text-red rtl:mr-3',
    thAnswers: 'inline-flex items-center text-turquoise',
    thSeeMore: 'font-bold text-turquoise text-md underline rtl:ml-auto',
  }),
};
